/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSbpIcon16Light = forwardRef('LogoSbpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.252 1.043a.5.5 0 0 1 .5-.002l5.48 3.132a.5.5 0 0 1-.001.869L9.024 8l5.207 2.958a.5.5 0 0 1 .001.87l-5.48 3.131a.5.5 0 0 1-.749-.434V8.58l-5.256 2.987A.5.5 0 0 1 2 11.132V4.868a.5.5 0 0 1 .747-.435L8.003 7.42V1.475a.5.5 0 0 1 .249-.432ZM7 8 3 5.727v4.546L7 8Zm2.003 1.138 3.971 2.256-3.971 2.27V9.137Zm0-2.276V2.337l3.971 2.269-3.971 2.256Z" })));
});
